import { CreditCardTracking } from '../../helpers/credit-card-tracking';
import { exposeSubscriptionUpsellEventsToWindow } from '../../components/subscription-upsell';
import {_t, _l, PaginationManager, tracking} from '@bark/bark-core';
import { exposeQuickScrollToWindow } from '@bark/bark-core';
import {_n, currency} from "@bark/bark-core/src/helpers/number-formatting";
import { getFullLocale } from "@bark/bark-core/src/helpers";
import {
    isUSTaxComplianceActive,
    isUSTaxCompliant,
    continueToBusinessAddress,
    saveBusinessAddress,
    initializeGooglePlacesAutoComplete
} from "@bark/bark-core";

import {
	exposeCreditCardModalToWindow,
	exportPaymentMethodsToWindow,
} from '../../components/payments';
import { AsYouType } from 'libphonenumber-js';
import moment from "moment/moment";
import {generateWalletOptions} from "../../helpers/payments/helpers";

export default function MyCreditsSettings() {
	exposeQuickScrollToWindow();
	exposeSubscriptionUpsellEventsToWindow();
	exposeCreditCardModalToWindow();
	exportPaymentMethodsToWindow();

	const creditCardTracking = CreditCardTracking();

	/**
	 * Window.Bark global
	 * @type {Window.Bark}
	 */
	var Bark = (window.Bark = window.Bark || {});

	/**
	 * Window.Bark.credits global
	 * @type {Window.Bark.credits}
	 */
	var credits = (Bark.credits = Bark.credits || {});

	/**
	 * An object containing a list of pending Ajax requests
	 * @type {object}
	 */
	var pendingAjax = { credits: false, transactions: false, freeResponses: false };

	/**
	 * Flag to determine whether we are allowed to load more transactions
	 * @type {boolean}
	 */
	var allowCheckTransactions = true;

	/**
	 * Flag to determine whether we are allowed to load more free responses
	 * @type {boolean}
	 */
	var allowCheckFreeResponses = true;

	/**
	 * Amount of paginated items to load at a time
	 * @type {number}
	 */
	var paginationItems = 10;

	/**
	 * Enter key
	 * @type {number}
	 */
	var KEY_CODE_ENTER = 13;

	/**
	 * Elite Pro Module
	 */
	var eps = null;

	var creditsInfo = {
		n_responses: null,
		base_credits_per_response: null,
		advertised_price: null,
		advertised_discount: null,
	};

	let USTaxCompliantStatus = null;

	let paginationManager;

	/**
	 * Data used to render the credits page
	 * @type {object}
	 */
	credits.data = {
		creditPacks: [],
		transactions: [],
		freeResponses: [],
		largePackData: false,
	};

	credits.self = {};

	/**
	 * HandleBars templates
	 * @type {object}
	 */
	credits.templates = {
		couponPackRow: false,
		couponStarterPackRow: false,
		couponSubscriptionRow: false,
		couponSubscriptionFreebieRow: false,
		creditPackRow: false,
		freeResponsesRow: false,
		loader: Handlebars.compile(document.getElementById('handlebars-loader').innerHTML),
		singlePurchasePackRow: false,
		transactionRow: false,
	};

	var currentPurchaseId;

	var currentUpsellId;

	var purchasing = false;

	var registeringCard = false;

	var setAsAtu;

	var cardFormAction = 'purchase';

	var clearCouponCode = true;

	var sellerRetryAttempts = 0;

	var largePackDefaultResponse = 50;

	var redirectAfterSuccess = false;

	let $cardModal;
	let $multiPaymentModal;
	let cardModalOptions = null;
	let sellerProfileId;
	let primaryPaymentMethod;
	let isCardAvailable = () => {
		return (
			typeof primaryPaymentMethod != 'undefined' &&
			primaryPaymentMethod != false &&
			primaryPaymentMethod?.id !== null
		);
	};

	let multiPaymentModalSelector = '#multi-payment-modal';
	let multiPaymentConfirmSelector = '.js-payment-modal-confirm';
	let lastPackModalSelector;

	const SAVED_CARD = 'saved-card';
	const NEW_CARD = 'new-card';
	const SOFORT = 'sofort';

	let paymentRequest = {};

	const paymentModalSuccess = async (token) => {
		if (Bark.in_array(cardFormAction, ['coupon', 'subscription'])) {
			clearCouponCode = false;
		}

		Bark.showLoading();

		primaryPaymentMethod = false;

		if (cardFormAction === 'purchase') {
			purchaseCredits(currentPurchaseId, setAsAtu, token.id);
		} else if (cardFormAction === 'purchase-upsell') {
			purchaseUpsell(currentUpsellId);
		} else if (cardFormAction === 'coupon') {
			purchaseCouponPack($('#coupon-code').val().trim(), currentPurchaseId, token.id);
		} else if (cardFormAction === 'large_pack') {
			purchaseLargePack(Number($('#large-pack-modal .js-range-slider').val()), token.id);
		} else {
			registerNewCard(token.id);
		}
	};

	const multiPaymentModalSuccess = async (token) => {
		if (Bark.in_array(cardFormAction, ['coupon', 'subscription'])) {
			clearCouponCode = false;
		}

		Bark.showLoading();

		primaryPaymentMethod = false;
		let tokenId = token?.id;
		let nResponses = Number($('#large-pack-modal .js-range-slider').val());
		let code = $('#coupon-code').val().trim();

		if (
			isMultiPaymentModalAvailable() &&
			lastPackModalSelector === 'multi-payment-modal'
		) {
			if (
				typeof currentPurchaseId == 'undefined' ||
				currentPurchaseId == '' ||
				currentPurchaseId == null
			) {
				currentPurchaseId = $multiPaymentModal.data('plan-id');
				setAsAtu = $multiPaymentModal.data('set-as-atu');
			}
			if (
				typeof currentUpsellId == 'undefined' ||
				currentUpsellId == null ||
				currentUpsellId == ''
			) {
				currentUpsellId = $multiPaymentModal.data('plan-id');
			}
			if ($multiPaymentModal.data('n_responses') > 0) {
				currentUpsellId = null;
				currentPurchaseId = null;
				nResponses = $multiPaymentModal.data('n_responses');
				cardFormAction = 'large_pack';
			}

			if ($multiPaymentModal.data('code') && $multiPaymentModal.data('code').length) {
				currentPurchaseId = $multiPaymentModal.data('plan-id');
				code = $multiPaymentModal.data('code');
				cardFormAction = 'coupon';
			}

			if (
				$multiPaymentModal
					.find('.js-payment-modal-confirm')
					.attr('data-payment-method') === NEW_CARD
			) {
				Bark.showLoading();
				try {
					await window.BarkPaymentsCardModal.confirmSetupIntent(
						$cardModal.data('user-id'),
						token.id,
					);
					await getCreditCard();
					tokenId = null;
					if (cardFormAction === 'purchase') {
						purchaseCredits(currentPurchaseId, setAsAtu, tokenId);
					} else if (cardFormAction === 'purchase-upsell') {
						purchaseUpsell(currentUpsellId);
					} else if (cardFormAction === 'coupon') {
						purchaseCouponPack(code, currentPurchaseId, tokenId);
					} else if (cardFormAction === 'large_pack') {
						purchaseLargePack(nResponses, tokenId);
					} else {
						registerNewCard(token.id);
					}
				} catch (e) {
					const error = handleErrors(
						e?.error || {},
						_t('seller_settings_credits:errors.problem-with-card'),
					);
					Bark.hideLoading();
					console.error(e);
					window.bugsnagClient && window.bugsnagClient.notify(e);
					lastPackModalSelector = $multiPaymentModal.attr('id');
					window.Bark.alertModal(
						_t('seller_settings_credits:payment-card-modal.errors.card-processing-error'),
					);
					return;
				}
			}
			return;
		}

		if (cardFormAction === 'purchase') {
			purchaseCredits(currentPurchaseId, setAsAtu, tokenId);
		} else if (cardFormAction === 'purchase-upsell') {
			purchaseUpsell(currentUpsellId);
		} else if (cardFormAction === 'coupon') {
			purchaseCouponPack(code, currentPurchaseId, tokenId);
		} else if (cardFormAction === 'large_pack') {
			purchaseLargePack(nResponses, tokenId);
		} else {
			registerNewCard(token.id);
		}
	};

	const paymentModalClosed = () => {
		if (Bark.in_array(cardFormAction, ['coupon', 'subscription']) && clearCouponCode) {
			$('#coupon-code').val('');
		}
		QS.deleteValue('payment_intent');
		QS.updateBrowserQuerystring();
	};

	const closeMultiPaymentModal = () => {
		$('#payment-accordion .payment-body ').collapse('hide');
		QS.deleteValue('payment_intent');
		QS.updateBrowserQuerystring();
	};

	const savedCardCallback = ($modal, successCallback, $selector) => (event) => {
		event.preventDefault();
		var button = $(this);
		var originalText = button.text();
		button.addClass('loading').prop('disabled', true);
		var $container = $modal;
		let nResponses = Number($('#large-pack-modal .js-range-slider').val());
		let code = $('#coupon-code').val().trim();
		if (isMultiPaymentModalAvailable()) {
			if (typeof currentPurchaseId == 'undefined' || currentPurchaseId == '') {
				currentPurchaseId = $multiPaymentModal.data('plan-id');
				setAsAtu = $multiPaymentModal.data('set-as-atu');
			}
			if (
				typeof currentUpsellId == 'undefined' ||
				currentUpsellId == null ||
				currentUpsellId == ''
			) {
				currentUpsellId = $multiPaymentModal.data('plan-id');
			}

			if ($multiPaymentModal.data('n_responses') > 0) {
				currentUpsellId = null;
				currentPurchaseId = null;
				nResponses = $multiPaymentModal.data('n_responses');
				cardFormAction = 'large_pack';
			}

			if ($multiPaymentModal.data('code') && $multiPaymentModal.data('code').length) {
				code = $multiPaymentModal.data('code');
				cardFormAction = 'coupon';
			}
		}
		window.BarkPaymentsCardModal.confirmButtonSetLoadingState(
			$modal,
			true,
			multiPaymentConfirmSelector,
		);
		new Promise(function (resolve, reject) {
			$modal.modal('hide');
			if (cardFormAction === 'purchase' && $container.data('upsellCard')) {
				resolve(purchaseCredits($container.data('plan-id'), setAsAtu));
			} else if (cardFormAction === 'purchase' && !$container.data('upsellCard')) {
				resolve(purchaseCredits($container.data('plan-id'), setAsAtu));
			} else if (cardFormAction === 'purchase') {
				resolve(purchaseCredits($container.data('plan-id'), setAsAtu));
			} else if (cardFormAction === 'purchase-upsell') {
				resolve(purchaseUpsell($container.data('plan-id')));
			} else if (cardFormAction === 'coupon') {
				resolve(purchaseCouponPack(code, currentPurchaseId));
			} else if (cardFormAction === 'large_pack') {
				resolve(purchaseLargePack(nResponses));
			} else {
				reject();
			}
		})
			.then(() => {
				currentUpsellId = null;
				currentPurchaseId = null;
				code = null;
				$multiPaymentModal.data({});
			})
			.finally(() => {
				window.BarkPaymentsCardModal.confirmButtonSetLoadingState(
					$modal,
					false,
					multiPaymentConfirmSelector,
				);
				QS.deleteValue('payment_intent');
				QS.updateBrowserQuerystring();
			});
	};

	const isMultiPaymentModalAvailable = () => {
		return document.getElementById('multi-payment-modal');
	};
	/**
	 * Load the entire page
	 */
	async function loadPage() {
		getSelf();
		$cardModal = window.BarkPaymentsCardModal.initCardModal(
			'.js-card-payment-modal',
			paymentModalSuccess,
			paymentModalClosed,
			paymentModalClosed,
		);

		if (isMultiPaymentModalAvailable()) {
			$multiPaymentModal = window.BarkPaymentsCardModal.initMultiPaymentCardModal(
				multiPaymentModalSelector,
				multiPaymentModalSuccess,
				closeMultiPaymentModal,
				closeMultiPaymentModal,
				savedCardCallback,
			).data({
				country: Bark.LOCALE.iso2c,
				defaultPaymentMethod: SAVED_CARD,
			});
		}
		// call api to purchase credit pack via using existing card
		sellerProfileId = $cardModal.data('seller-profile-id');
		primaryPaymentMethod = await getPrimaryPaymentMethod(sellerProfileId);

		credits.getCreditPacks();
		credits.getFreeResponses();
		credits.getTransactionLog();

		renderCardRow(primaryPaymentMethod);

		if (isUSTaxComplianceActive()) {
			USTaxCompliantStatus = await isUSTaxCompliant();
			if (!USTaxCompliantStatus) {
				initializeGooglePlacesAutoComplete();
			}
		}
	}

	function getByKey(array, id, key = undefined) {
		var i;

		if (!key) {
			key = 'id';
		}

		for (i = 0; i < array.length; i++) {
			if (array[i][key] === id) {
				return array[i];
			}
		}

		return false;
	}

	/**
	 * Get data about the card details
	 */
	async function getCreditCard() {
		$('.js-card-details-row').addClass('d-none');
		primaryPaymentMethod = await getPrimaryPaymentMethod(sellerProfileId);
		renderCardRow(primaryPaymentMethod);
	}

	function getSelf() {
		Bark.api(
			'seller/self',
			null,
			function (e) {
				credits.self = e.data;
				Bark.sellerSelfObject = e.data;

				if (window.SubscriptionUpsellFunctions.IsSubscriptionUpsellActive()) {
					tracking('credit_subscription', 'my_credit_CTA_shown', {
						seller_profile_id: credits?.self?.spf_id,
						country_id: credits?.self?.country_id,
					});
					window.SubscriptionUpsellFunctions.SubscriptionUpsellBindEvents(credits.self);
				}
			},
			function (err) {
				showErrors(err);
			},
		);
	}

	/**
	 * Render the card details row
	 * @param {object} cardDetails An object describing the card details that a seller has on record
	 */
	function renderCardRow(cardDetails) {
		if (cardDetails) {
			$('.js-card-details-row').removeClass('d-none');
			$('.js-card-details-row .js-card-brand').attr({
				src: cardDetails.card_brand_image,
			});
			$('.js-card-details-row .js-card-last-four').text(cardDetails.card_number);

			if (isMultiPaymentModalAvailable()) {
				$('.response-modal-card-number-suffix').text(cardDetails.card_number);
				$('.response-modal-card-expiry-date').text(
					`${cardDetails.card_expiry_month}/${cardDetails.card_expiry_year.slice(-2)}`,
				);
				$('.response-modal-card-brand-name').text(cardDetails.card_brand);
				$('.response-modal-card-brand')
					.empty()
					.append(
						$('<img>', {
							class: 'img-fluid',
							src: cardDetails.card_brand_image,
						}),
					);
			}
		}
	}

	/**
	 * Render the starter pack
	 * @param {object} starterPack An object describing a starter pack
	 */
	function renderStarterPack(starterPack) {
		$('.js-credit-packs-container').addClass('d-none');
		$('.js-starter-pack-container').removeClass('d-none');
		$('.js-starter-pack-container').trigger('spack.show');
		$('.js-starter-pack-container .js-discount-pct').text(starterPack.discount);
		$('.js-starter-pack-container .js-estimated-responses').text(starterPack.responses);
		$('.js-starter-pack-container .js-n-credits').text(_n(starterPack.credits));
		$('.js-starter-pack-container .js-currency-symbol').text('');
		$('.js-starter-pack-container .js-price').text(
			currency(starterPack.discounted_price),
		);
		$('.js-starter-pack-container .js-vat-toggle')[
			starterPack.vat > 1 || $('#js-show-tax-disclaimers-us').length
				? 'removeClass'
				: 'addClass'
		]('d-none');
		$('.js-starter-pack-container .js-price-per-credit').text(
			currency(starterPack.price_per_credit),
		);

		$('.js-starter-pack-container .js-purchase-pack').attr({
			'data-pack-id': starterPack.id,
			'data-credits': starterPack.credits,
			'data-pack-price': starterPack.discounted_price,
			'data-price-per-credit': starterPack.price_per_credit,
		});
		bindPurchaseHandler();
	}

	/**
	 * Render the credits packs
	 * @param {array} packs An array of objects, with each object describing either a starter pack or a credit pack
	 */
	function renderCreditPacks(packs) {
		var starterPack = getByKey(packs, 'spack');
		var atuSet = false;
		var i;

		if (starterPack) {
			renderStarterPack(starterPack);
			return;
		}

		if (!credits.templates.creditPackRow) {
			credits.templates.creditPackRow = Handlebars.compile(
				document.getElementById('handlebars-credit-pack-row').innerHTML,
			);
		}

		$('.js-starter-pack-container').addClass('d-none');
		$('.js-credit-packs-container').removeClass('d-none');
		$('.js-credit-packs-container .js-packs').empty();

		for (i = 0; i < packs.length; i++) {
			if (packs[i].autotopup) {
				atuSet = true;
			}
		}

		for (i = 0; i < packs.length; i++) {
			$('.js-credit-packs-container .js-packs').append(
				credits.templates.creditPackRow({
					pack_id: packs[i].id,
					estimated_responses: packs[i].responses,
					estimate_responses_string: _t(
						'seller_settings_credits:credit-pack-template.estimated-number-of-responses',
						{
							number_of_starter_pack_responses: _n(packs[i].responses),
						},
					),
					n_credits: _n(packs[i].credits),
					n_credits_string: _t(
						'seller_settings_credits:credit-pack-template.total-credits-in-pack',
						{
							total_credits: _n(packs[i].credits),
						},
					),
					currency_symbol: '',
					pack_price: currency(packs[i].discounted_price),
					pack_price_value: packs[i].discounted_price,
					has_vat: +packs[i].vat > 1 || $('#js-show-tax-disclaimers-us').length,
					price_per_credit: packs[i].price_per_credit,
					price_per_credit_string: _t(
						'seller_settings_credits:credit-pack-template.price-per-credit-in-pack',
						{
							price_per_credit: currency(packs[i].price_per_credit),
						},
					),
					is_best_value: i + 1 === packs.length,
					discount: packs[i].discount,
					discount_string: _t(
						'seller_settings_credits:credit-pack-template.discount-percent',
						{
							discount_percent: packs[i].discount,
						},
					),
					autotopup_available: packs[i].autotopup_available,
					auto_top_up_checked: packs[i].auto_top_up_checked,
					autotopup: packs[i].autotopup,
					autotopup_set: atuSet,
					is_last: i + 1 === packs.length,
					larger_credit_pack_discount_price: currency(packs[i].price * 0.8),
					larger_credit_pack_discount_price_per_credit: _t(
						'seller_settings_credits:credit-pack-template.price-per-credit-in-pack',
						{
							price_per_credit: currency((packs[i].price / packs[i].credits) * 0.8),
						},
					),
					original_price: currency(packs[i].price),
					original_price_per_credit: _t(
						'seller_settings_credits:credit-pack-template.price-per-credit-in-pack',
						{
							price_per_credit: currency(packs[i].price / packs[i].credits),
						},
					),
				}),
			);
		}

		if (atuSet) {
			$('.js-atu-header-off').addClass('d-none');
			$('.js-atu-header-on').removeClass('d-none');
			$('.js-credits-page-view .js-atu-options').removeClass('d-none');
		} else {
			$('.js-atu-header-off').removeClass('d-none');
			$('.js-atu-header-on').addClass('d-none');
			$('.js-credits-page-view .js-atu-options').addClass('d-none');
		}

		bindPurchaseHandler();

		$('.js-set-as-atu')
			.off('click.setasatu')
			.on('click.setasatu', function () {
				var packId = $(this).data('pack-id');
				var toggledEl = $(this);
				if (toggledEl.hasClass('bg-success')) {
					return;
				}
				toggledEl.addClass('text-grey-100 cursor-original');
				toggledEl.removeClass('cursor-pointer border-hover-primary');
				Bark.api(
					'seller/autotopup',
					{ pid: packId },
					function () {
						toggledEl.removeClass('waiting');
						$('.atu-button').removeClass('cursor-original bg-success text-white');
						$('.atu-button').addClass(
							'text-primary cursor-pointer border border-grey-100 border-hover-primary js-set-as-atu',
						);
						$('.atu-button').html(
							`<span class="">${_t(
								'seller_settings_credits:auto-topup.set-as-auto-topup',
							)}</span>`,
						);
						toggledEl.removeClass(
							'js-set-as-atu text-primary cursor-pointer border border-grey-100 border-hover-primary',
						);
						toggledEl.removeClass('text-grey-100');
						toggledEl.addClass('cursor-original bg-success text-white');
						toggledEl.html(
							`<span class="micons-check_circle mr-2"></span>${_t(
								'seller_settings_credits:auto-topup.is-set-as-auto-topup',
							)}`,
						);
					},
					function (err) {
						showErrors(err);
					},
					'POST',
				);
			});
	}

	function choosePackDefinition(discountOptions, nResponses) {
		var i;
		var chosen = false;

		for (i = 0; i < discountOptions.length; i++) {
			var z = discountOptions[i];
			if (nResponses >= z.n_responses) {
				chosen = z;
			}
		}

		return chosen;
	}

	function updateLargePackModalData(largePackData, nResponses) {
		var def = choosePackDefinition(largePackData.discount_options, nResponses);
		var scope = $('#large-pack-modal');
		var nCredits = nResponses * largePackData.base_credits_per_response;
		var ppc = largePackData.price_per_credit / 100;
		var advertisedPrice = nCredits * ppc * (1 - def.discount_percent / 100);

		$('.js-large-pack-n-responses', scope).text(nResponses);
		$('.js-large-pack-n-credits', scope).text(
			_n(nResponses * largePackData.base_credits_per_response),
		);
		$('.js-large-pack-currency-symbol', scope).text('');
		$('.js-large-pack-discount-pct', scope).text(def.discount_percent);
		$('.js-large-pack-price', scope).text(currency(advertisedPrice));
		$('.js-large-pack-old-price', scope).text(currency(nCredits * ppc));
		$('.js-large-pack-ex-vat', scope)[
			largePackData.vat_rate > 1 || $('#js-show-tax-disclaimers-us').length
				? 'removeClass'
				: 'addClass'
		]('d-none');

		creditsInfo = {
			n_responses: nResponses,
			base_credits_per_response: largePackData.base_credits_per_response,
			advertised_price: currency(advertisedPrice),
			advertised_discount: _n(def.discount_percent),
		};
	}

	let animationTimeouts = {};

	let calloutAlwaysSet = false;

	/**
	 * Toggle the partnerships callout if the amount of credits passes the threshold
	 * @param {int} baseCreditsPerResponse
	 * @param {int} nResponses
	 * @param {bool} isInitial
	 */
	const togglePartnershipsCallout = (
		baseCreditsPerResponse,
		nResponses,
		isInitial = false,
	) => {
		let threshold = 1000;
		let passesThreshold = baseCreditsPerResponse * nResponses >= threshold;
		let container = $('.js-large-pack-partnerships-callout');
		let inner = $('.js-large-pack-partnerships-callout-inner');
		let innerHeight = inner[0].getBoundingClientRect().height;
		let speed = 400;

		if (calloutAlwaysSet) {
			return;
		}

		if (isInitial && passesThreshold) {
			container.addClass('force-open');
			calloutAlwaysSet = true;
			return;
		}

		animationTimeouts.partnershipsCallout !== undefined &&
			window.clearTimeout(animationTimeouts.partnershipsCallout);

		if (passesThreshold) {
			// If closed, open it
			if (!container.hasClass('open')) {
				container.height(innerHeight);

				animationTimeouts.partnershipsCallout = window.setTimeout(() => {
					container.height('auto');
				}, speed);
			}
		} else {
			// If open, close it
			container.height(innerHeight);
			container.height(0);
			container.removeClass('open');
		}
	};

	function sanitizeNResponses(nResponses, increments, minResponses, maxResponses) {
		if (nResponses % increments > 0) {
			nResponses = Math.round(nResponses / increments) * increments;
		}

		if (nResponses < minResponses) {
			nResponses = minResponses;
		}

		if (nResponses > maxResponses) {
			nResponses = maxResponses;
		}

		return nResponses;
	}

	function displayLargePack(lpData, nResponses) {
		var slider = $('.js-range-slider').data('ionRangeSlider');
		var maxResponses = Bark.end(lpData.discount_options).n_responses;
		var minResponses = lpData.discount_options[0].n_responses;
		var nResponsesSantized = sanitizeNResponses(
			nResponses,
			lpData.value_increment,
			minResponses,
			maxResponses,
		);

		$('#large-pack-modal').modal('show');

		updateLargePackModalData(lpData, nResponsesSantized);

		if (!slider) {
			$('.js-range-slider').ionRangeSlider({
				skin: 'round',
				grid: true,
				hide_min_max: true,
				hide_from_to: true,
				grid_margin: true,
				from_min: lpData.value_min,
				min: lpData.slider_min,
				max: lpData.slider_max,
				step: lpData.value_increment,
				grid_num: lpData.number_of_labels,
			});

			slider = $('.js-range-slider').data('ionRangeSlider');
		}

		slider.update({
			from: nResponsesSantized,
			onChange: function (data) {
				updateLargePackModalData(lpData, data.from);
				togglePartnershipsCallout(lpData.base_credits_per_response, data.from);
			},
		});

		togglePartnershipsCallout(lpData.base_credits_per_response, lpData.value_min, true);
		togglePartnershipsCallout(lpData.base_credits_per_response, nResponsesSantized);
	}

	/**
	 * Append to the credit transactions table
	 * @param {array} transactions An array of objects, with each object describing a free response
	 */
	function appendToTransactions(transactions) {
		var i;
		var transaction;

		if (transactions.length) {
			$('.js-credit-transactions-section').removeClass('d-none');
		}

		if (!credits.templates.transactionRow) {
			credits.templates.transactionRow = Handlebars.compile(
				document.getElementById('handlebars-transaction-row').innerHTML,
			);
		}

		for (i = 0; i < transactions.length; i++) {
			transaction = transactions[i];
			var transactionDate = new Date(transaction.created.split(' ')[0]);
			var friendlyDate = transactionDate.toLocaleString(getFullLocale(), {
				day: 'numeric',
				month: 'short',
				year: 'numeric',
			});
			$('.js-credit-transaction-table .js-pseudo-body').append(
				credits.templates.transactionRow({
					transaction_id: transaction.id,
					transaction_desc: localiseTransactionDescription(
						transaction.description,
						transaction.adjustment < 0
							? transaction.adjustment * -1
							: transaction.adjustment,
					),
					adjustment: _n(transaction.adjustment),
					adjustment_direction_class: transaction.adjustment > 0 ? 'text-green' : '',
					date: friendlyDate,
					date_string: _t(
						'seller_settings_credits:credit-transaction-log.table-row.date-of-transaction',
						{
							date_of_transaction: friendlyDate,
						},
					),
				}),
			);
		}
	}

	function localiseTransactionDescription(description, amt) {
		if (!description) {
			return '-';
		}

		var map = {
			'([0-9,\\.]+) credits? used to reply to customer': [
				'n-credits-used-to-reply-to-customer',
				{ total_credits: 1, count: 1 },
			],
			'([0-9,\\.]+) credits used to reply to customer \\(who contacted you\\)': [
				'n-credits-used-to-reply-to-customer-buyer-contacted',
				{ total_credits: 1, count: 1 },
			],
			'([0-9,\\.]+) credits? purchased': [
				'n-credits-purchased',
				{ total_credits: 1, count: 1 },
			],
			'([0-9,\\.]+) credits? purchased at ([0-9,\\.]+)% off': [
				'n-credits-purchased-at-discount',
				{ total_credits: 1, count: 1, discount_percent: 2 },
			],
			'([0-9,\\.]+) credits purchased \\(one time offer\\)': [
				'n-credits-purchased-one-time-offer',
				{ total_credits: 1, count: 1 },
			],
			'([0-9,\\.]+) free response used to reply to customer': [
				'free-response-used-in-reply',
				{ total_free_responses: 1, count: 1 },
			],
			'([0-9,\\.]+) free response used to reply to customer \\(who contacted you\\)': [
				'free-response-used-in-reply-buyer-contacted',
				{ total_free_responses: 1, count: 1 },
			],
			'Starter Pack: ([0-9,\\.]+) offer credits? purchased': [
				'starter-pack-purchased',
				{ total_credits: 1, count: 1 },
			],
			'Starter Pack: ([0-9,\\.]+) offer credits purchased using voucher\\s+\\(([^\\)\\s]*)\\)':
				['starter-pack-purchased-coupon', { total_credits: 1, count: 1, coupon_code: 2 }],
			'Credits returned': ['credits-returned'],
			'([0-9,\\.]+) credits purchased using voucher\\s+\\(([^\\)]*), ([0-9,\\.]+) of ([0-9,\\.]+)\\)':
				[
					'n-credits-purchased-with-coupon-multiple',
					{
						total_credits: 1,
						count: 1,
						coupon_code: 2,
						coupon_redemption_number: 3,
						total_coupon_redemptions: 4,
					},
				],
			'([0-9,\\.]+) credits purchased using voucher\\s+\\(([^\\)\\s]*)\\)': [
				'n-credits-purchased-with-coupon',
				{ total_credits: 1, count: 1, coupon_code: 2 },
			],
			'Starter Pack: ([0-9,\\.]+) offer credits purchased \\+ ([0-9,\\.]+) free\\s+\\(([^\\)]*), ([0-9,\\.]+) of ([0-9,\\.]+)\\)':
				[
					'starter-pack-purchased-free-credits-voucher-multiple',
					{
						total_credits: 1,
						count: 1,
						free_credits: 2,
						coupon_code: 3,
						coupon_redemption_number: 4,
						total_coupon_redemptions: 5,
					},
				],
			'Starter Pack: ([0-9,\\.]+) offer credits purchased \\+ ([0-9,\\.]+) free\\s+\\(([^\\)\\s]*)\\)':
				[
					'starter-pack-purchased-free-credits-voucher',
					{
						total_credits: 1,
						count: 1,
						free_credits: 2,
						coupon_code: 3,
					},
				],
			'([0-9,\\.]+) credits purchased \\(via Outbound\\)': [
				'n-credits-purchased-via-outbound',
				{ total_credits: 1, count: 1 },
			],
			'([0-9,\\.]+) credits purchased \\(via Outbound with Credit Back Guarantee\\)': [
				'n-credits-purchased-via-outbound-guaranteed',
				{ total_credits: 1, count: 1 },
			],
		};

		return localiseInputString(
			description,
			'credit-transaction-log.table-row.values',
			map,
			amt,
		);
	}

	function localiseInputString(inputString, baseKey, map, amt) {
		var namespace = 'seller_settings_credits';

		for (var mapKey in map) {
			try {
				var regex = new RegExp(`^${mapKey}$`);
				var matches = regex.exec(inputString);
				var replacements = {};

				if (!matches || !matches.length) {
					continue;
				}

				var replacementList = map[mapKey][1];

				if (replacementList) {
					for (var replacementMap in replacementList) {
						var replacementIndex = replacementList[replacementMap];
						replacements[replacementMap] =
							replacementMap === 'count'
								? replacementList['count']
								: identifyNumber(matches[replacementIndex]);
					}
					if (amt !== 0) replacements['count'] = amt;
				}

				var key = `${baseKey}.${map[mapKey][0]}`;
				var newString = _t(`${namespace}:${key}`, replacements);
				inputString =
					newString === key || newString.match('{{') ? inputString : newString; // If the string is untranslated, return input
				break;
			} catch (e) {
				console.error(e);
				window.bugsnagClient && window.bugsnagClient.notify(e);
			}
		}

		return inputString;
	}

	const identifyNumber = (input) => {
		if (input.slice(-3, -2) === ',') {
			// If the string is a number and it is numeric
			return input;
		}

		const re = new RegExp(`[,\s]`, 'g');
		const numericOnly = input.replace(re, '');

		if (isNaN(numericOnly)) {
			return input;
		}

		return _n(numericOnly);
	};

	/**
	 * Append to the free responses table
	 * @param {array} freeResponses An array of objects, with each object describing a free response
	 */
	function appendToFreeResponses(freeResponses) {
		var i;
		var response;
		var freeResponsesEnabled;

		if (freeResponses.length) {
			$('.js-free-responses-section').removeClass('d-none');
		}

		if (!credits.templates.freeResponsesRow) {
			credits.templates.freeResponsesRow = Handlebars.compile(
				document.getElementById('handlebars-free-responses-row').innerHTML,
			);
		}

		for (i = 0; i < freeResponses.length; i++) {
			response = freeResponses[i];

			freeResponsesEnabled = response.is_enabled;
			var created = moment(response.created, 'D MMM YYYY, HH:mm')
				.toDate()
				.toLocaleString(getFullLocale(), {
					day: 'numeric',
					month: 'short',
					year: 'numeric',
				});
			var expires_friendly = moment(response.expires_friendly, 'D MMM YYYY, HH:mm')
				.toDate()
				.toLocaleString(getFullLocale(), {
					day: 'numeric',
					month: 'short',
					year: 'numeric',
				});

			$('.js-free-responses-table .js-pseudo-body').append(
				credits.templates.freeResponsesRow({
					id: response.id,
					date_applied:
						created ||
						_t('seller_settings_credits:free-responses-log.date-not-applicable'),
					expires:
						expires_friendly ||
						_t('seller_settings_credits:free-responses-log.never-expires'),
					description: localiseFreeResponseDescription(response.description),
				}),
			);
		}

		setFreeResponseToggleText(freeResponsesEnabled);
	}

	function localiseFreeResponseDescription(description) {
		if (!description) {
			return '-';
		}

		var map = {
			'Free trial lead': ['free-trial-lead'],
			'Free response from coupon \\(([^\\)]*)\\)': [
				'free-response-from-coupon',
				{ coupon_code: 1 },
			],
		};

		return localiseInputString(description, 'free-responses-log.table-row.values', map);
	}

	/**
	 * Set the free responses toggle text
	 * @param {boolean} freeResponsesEnabled
	 */
	function setFreeResponseToggleText(freeResponsesEnabled) {
		var entireLength = credits.data.freeResponses.length;
		$('.free-resp-count').text(entireLength);
	}

	/**
	 * Submit a coupon
	 * @param {string} couponCode
	 */
	function submitCoupon(couponCode) {
		$('.js-coupon-code-error').removeClass('d-block');
		$('#coupon-code').removeClass('border-red');

		if (!couponCode) {
			$('.js-coupon-code-error')
				.addClass('d-block')
				.text(_t('seller_settings_credits:coupon-input.errors.enter-valid-code'));
			$('#coupon-code').addClass('border-red').focus();
			return;
		}

		Bark.showLoading();

		$('body').focus(); // Remove focus from the input field to prevent a double enter

		var params = { code: couponCode };
		params = admh(params);

		Bark.api(
			'seller/apply-coupon',
			params,
			function (e) {
				var i;
				var pack;

				if (e.data) {
					if (e.data.action === 'msg') {
						$('#coupon-code').val('');

						$('.js-coupon-applied-msg').text(e.data.msg);
						$('#coupon-applied-modal').modal('show');

						switch (e.data.type) {
							case 'free_response':
								allowCheckFreeResponses = true;
								credits.data.freeResponses = [];
								credits.getFreeResponses();
								break;

							case 'credits':
								allowCheckTransactions = true;
								credits.data.transactions = [];
								credits.getTransactionLog();
								break;
						}
					} else if (e.data.action === 'purchase-pack') {
						var modalContainer,
							isStarterPack = false;
						// Initialise the two templates
						if (!credits.templates.couponPackRow) {
							credits.templates.couponPackRow = Handlebars.compile(
								document.getElementById('handlebars-coupon-pack-row').innerHTML,
							);
						}
						if (!credits.templates.couponStarterPackRow) {
							credits.templates.couponStarterPackRow = Handlebars.compile(
								document.getElementById('handlebars-coupon-starter-pack-row').innerHTML,
							);
						}

						if (e.data.is_starter_pack) {
							modalContainer = $('#atu-coupon-starter-packs');
						} else {
							modalContainer = $('#atu-coupon-credit-packs');
						}

						$('.js-coupon-pack-container', modalContainer).empty();

						$('.js-coupon-packs-title', modalContainer).text(
							e.data.title || _t('seller_settings_credits:coupon-input.coupon-is-valid'),
						);
						$('.js-coupon-packs-subtitle', modalContainer).text(e.data.subtitle || '');

						redirectAfterSuccess = e.data.success_redirect || false;

						for (i = 0; i < e.data.packs.length; i++) {
							pack = e.data.packs[i];

							if (e.data.is_starter_pack) {
								isStarterPack = true;
							}

							var row,
								templateData = {
									pack_id: pack.id,
									n_credits: _n(pack.n_credits),
									n_responses: _n(pack.n_responses),
									currency_symbol: pack.currency_symbol,
									pack_price: currency(pack.price),
									pack_price_value: parseFloat(pack.price_formatted),
									has_vat: pack.has_vat || $('#js-show-tax-disclaimers-us').length,
									price_per_credit: currency(pack.price_per_credit),
									price_per_credit_value: parseFloat(pack.price_per_credit_formatted),
									price_per_credit_with_symbol: currency(pack.price_per_credit),
									discount: pack.percentage,
									show_discount: pack.show_discount,
									no_discount_but_coupon: !pack.percentage && pack.free_credits,
									free_credits:
										typeof pack.free_credits === 'number' ? _n(pack.free_credits) : 0,
									total_credits:
										pack.n_credits +
										(typeof pack.free_credits === 'number' ? pack.free_credits : 0),
									original_price:
										pack.original_price_no_discount === pack.price
											? false
											: currency(pack.original_price_no_discount),
									original_price_with_symbol:
										pack.original_price_no_discount === pack.price
											? false
											: currency(pack.original_price_no_discount),
								};

							if (isStarterPack) {
								row = credits.templates.couponStarterPackRow(templateData);
							} else {
								row = credits.templates.couponPackRow(templateData);
							}

							$('.js-coupon-pack-container', modalContainer).append(row);
						}

						$('.js-purchase-coupon-pack')
							.off('click.purchasecouponpack')
							.on('click.purchasecouponpack', function () {
								currentPurchaseId = $(this).data('pack-id');
								const credits = $(this).data('credits');
								const pricePerCredit = $(this).data('pricePerCredit');
								const packPrice = $(this).data('packPrice');
								setAsAtu = false;
								// Starter pack modal will allow auto-topup
								if (
									isStarterPack &&
									$('#atu-toggle-spack-modal', modalContainer).filter(':checked').length
								) {
									setAsAtu = true;
								}
								modalContainer.modal('hide');

								if (isUSTaxComplianceActive() && !USTaxCompliantStatus) {
									let $callback = function () {
										triggerPurchaseWithCoupon(
											currentPurchaseId,
											credits,
											pricePerCredit,
											packPrice,
											setAsAtu,
										);
									};
									openUSTaxCompliantModal({}, 'Coupon');
									bindUSTaxComplianceNextAction($callback);
								} else {
									triggerPurchaseWithCoupon(
										currentPurchaseId,
										credits,
										pricePerCredit,
										packPrice,
										setAsAtu,
									);
								}
							});

						modalContainer.modal('show');
					} else if (
						Bark.in_array(e.data.action, [
							'purchase-subscription-coupon',
							'purchase-subscription-freebie',
						])
					) {
						document.location = _l(
							'/settings/profile/elite_pro/?coupon=' + $('#coupon-code').val().trim(),
						);
						return;
					}
				} else {
					$('.js-coupon-code-error')
						.addClass('d-block')
						.text(
							(e.errors || []).length
								? e.errors.join('. ')
								: _t('seller_settings_credits:coupon-input.errors.enter-valid-code'),
						);
					$('#coupon-code').addClass('border-red').focus();
				}
				Bark.hideLoading();
			},
			function (err) {
				Bark.hideLoading();
				var errorObj = handleErrors(
					err,
					_t('seller_settings_credits:coupon-input.errors.enter-valid-code'),
				);
				$('.js-coupon-code-error').addClass('d-block').text(errorObj.message);
				$('#coupon-code').addClass('border-red').focus();
			},
			'POST',
		);
	}

	const handleScaAuthenticationRequest = (
		client_secret,
		successCallback,
		failureCallback,
	) => {
		BarkPaymentsCardModal.promptUserAction(
			client_secret,
			(result) => {
				if (result?.paymentIntent) {
					successCallback(result?.paymentIntent);
				} else {
					purchasing = false;
					if (failureCallback) {
						failureCallback();
					} else {
						if (isMultiPaymentModalAvailable()) {
							BarkPaymentsCardModal.hideModalErrorText($multiPaymentModal);
							lastPackModalSelector = $multiPaymentModal.attr('id');
							BarkPaymentsCardModal.showMultiPaymentModal($multiPaymentModal, {
								resetFormAfterFailedSCA: true,
								...cardModalOptions,
								...paymentRequest,
							});
							BarkPaymentsCardModal.showModalErrorText(
								$multiPaymentModal,
								_t(
									'seller_settings_credits:payment-card-modal.errors.card-authentication-failure',
								),
							);
						} else {
							BarkPaymentsCardModal.hideModalErrorText($cardModal);
							BarkPaymentsCardModal.showCardModal($cardModal, {
								...cardModalOptions,
								...paymentRequest,
							});
							BarkPaymentsCardModal.showModalErrorText(
								$cardModal,
								_t(
									'seller_settings_credits:payment-card-modal.errors.card-authentication-failure',
								),
							);
						}
					}
				}
			},
			() => {
				// It is not clear if this is ever likely to happen, but we log it to bugsnag, so if it does a lot
				// then we can improve this error messaging.
				purchasing = false;
				window.Bark.alertModal(
					_t('seller_settings_credits:payment-card-modal.errors.card-processing-error'),
				);
			},
		);
	};

	/**
	 * Purchases credit packs
	 * @param {int|string} creditPackId The ID of the credit pack to purchase
	 * @param {boolean} setAsAutoTopup True to set this pack as the ATU pack
	 * @param {string|null} token [optional] A string to set as a new stripe token
	 * @param {string} paymentIntentId
	 */
	function purchaseCredits(creditPackId, setAsAutoTopup, token, paymentIntentId) {
		var payload = {
			cpid: creditPackId,
			autoTopupSetting: Number(setAsAutoTopup),
			sToken: token,
			paymentIntentId: paymentIntentId || null,
			tracking: Bark.getTrackableParameters(),
		};
		var pack;

		if (purchasing) {
			return false;
		}

		purchasing = true;

		Bark.showLoading();

		payload.paymentMethodId = token ? null : primaryPaymentMethod?.id || null;

		Bark.api(
			`/creditpack/${creditPackId}/purchase/`,
			payload,
			(e) => {
				packPurchaseComplete({
					sellerInvoiceId: e.data.seller_invoice_id,
					creditPackId,
					setAsAutoTopup,
					showUpsell: true,
					refreshCard: Boolean(token),
				});
			},
			function (error) {
				const errorResponse = error.responseJSON;
				purchasing = false;

				Bark.hideLoading();

				if (errorResponse?.error?.type === 'action_required') {
					handleScaAuthenticationRequest(
						errorResponse?.error?.error_data?.client_secret,
						(paymentIntent) => {
							purchaseCredits(creditPackId, setAsAutoTopup, null, paymentIntent.id);
							getCreditCard();
						},
						isMultiPaymentModalAvailable()
							? (err) => {
									purchasing = false;
									showErrors(err);
							  }
							: null,
					);
				} else {
					handleCardDecline(error);
				}
			},
			'POST',
		);
	}

	const packPurchaseComplete = ({
		sellerInvoiceId,
		creditPackId,
		setAsAutoTopup,
		showUpsell = true,
		refreshCard,
	}) => {
		purchasing = false;
		$('.modal').modal('hide');
		const pack = getByKey(credits.data.creditPacks, creditPackId);

		Bark.hideLoading();

		if (refreshCard) {
			getCreditCard();
		}

		if (setAsAutoTopup) {
			$('#atu-enabled-success-modal').modal('show');
			$('.js-atu-enabled-success-modal .js-n-credits-purchased').text(pack.credits);
		} else {
			if (
				showUpsell &&
				$('#credit-pack-row-' + creditPackId).hasClass('js-best-value-pack')
			) {
				showPurchaseSuccessModal(pack.credits);
			} else {
				if (isMultiPaymentModalAvailable()) {
					showPurchaseSuccessModal(pack.credits);
				} else if (showUpsell) {
					showPurchasePackUpsell(creditPackId);
				}
			}
		}

		updatePageCredits(pack.credits);

		allowCheckTransactions = true;

		// Reload the data
		credits.data.transactions = [];
		credits.data.creditPacks = [];

		credits.getTransactionLog();
		credits.getCreditPacks();

		trackPurchase({
			invoice_id: sellerInvoiceId,
			credits: pack.credits,
			price: pack.discounted_price,
			name: pack.id > 1 ? 'SellerAlloc' + pack.id : 'StarterPack',
		});

		paymentRequest = {};
	};

	const couponPackPurchaseComplete = ({
		nCredits,
		sellerInvoiceId,
		price,
		status,
		refreshCard,
		creditPackId,
	}) => {
		const pack = getByKey(credits.data.creditPacks, creditPackId);

		purchasing = false;
		Bark.hideLoading();

		if (status) {
			updatePageCredits(nCredits);
			showPurchaseSuccessModal(nCredits);

			$('#coupon-code').val('');
			clearCouponCode = true;

			allowCheckTransactions = true;

			credits.data.transactions = [];
			credits.data.creditPacks = [];

			credits.getCreditPacks();
			credits.getTransactionLog();

			if (refreshCard) {
				getCreditCard();
			}

			trackPurchase({
				invoice_id: sellerInvoiceId,
				credits: nCredits,
				price,
				name: pack.id > 1 ? 'SellerAlloc' + pack.id : 'StarterPack',
			});
		} else {
			showErrors({}, false, _t('seller_settings_credits:errors.adding-to-account'));
		}

		paymentRequest = {};
	};

	const largePackPurchaseComplete = ({
		sellerInvoiceId,
		nCredits,
		price,
		nResponses,
		refreshCard,
	}) => {
		purchasing = false;

		$('.modal').modal('hide');

		showPurchaseSuccessModal(nCredits);

		Bark.hideLoading();

		if (refreshCard) {
			getCreditCard();
		}

		updatePageCredits(nCredits);

		allowCheckTransactions = true;

		// Reload the data
		credits.data.transactions = [];
		credits.data.creditPacks = [];

		credits.getTransactionLog();
		credits.getCreditPacks();

		trackPurchase({
			invoice_id: sellerInvoiceId,
			credits: nCredits,
			price: price,
			n_responses: nResponses,
			name: 'LargePack',
		});

		paymentRequest = {};
	};

	const successModal = (data) => {
		const $modal = $(this).closest('.modal');
		$modal.modal('hide');
		showPurchaseSuccessModal(data.credits);
		QS.deleteValue('pack-type');
		QS.updateBrowserQuerystring();
		Bark.hideLoading();
	};

	async function onPaymentIntentSuccessRedirect() {
		if (!isMultiPaymentModalAvailable()) {
			return;
		}
		const paymentIntentId = QS.getValue('payment_intent', null);
		const isRedirectStatusSuccess = QS.getValue('redirect_status', null) === 'succeeded';
		if (paymentIntentId) {
			Bark.showLoading();
			$multiPaymentModal = window.BarkPaymentsCardModal.initMultiPaymentCardModal(
				multiPaymentModalSelector,
				multiPaymentModalSuccess,
				paymentModalClosed,
				paymentModalClosed,
				savedCardCallback,
			).data({
				country: Bark.LOCALE.iso2c,
			});
			primaryPaymentMethod = await getPrimaryPaymentMethod(sellerProfileId);

			if (primaryPaymentMethod?.id) {
				$('.js-saved-card').removeClass('d-none');
			}

			window.BarkPaymentsCardModal.confirmPaymentIntent(
				'sofort',
				paymentIntentId,
				Bark.USER.userId,
				successModal,
			)
				.then(async (data) => {
					console.log('Sofort payment confirmed', data?.is_paid);
					QS.deleteValue('payment_intent_client_secret');
					QS.deleteValue('redirect_status');
					if (data.is_paid) {
						QS.deleteValue('payment_intent');
						updatePageCredits(data.credits);

						credits.data.transactions = [];
						credits.data.creditPacks = [];
						credits.getCreditPacks();
						credits.getTransactionLog();
					} else {
						creditCardTracking.logAction('payment failure', {
							payment_method: 'sofort',
						});
					}
					QS.updateBrowserQuerystring();

					try {
						if (!isRedirectStatusSuccess) {
							let settings = {
								planId: data?.cpId == 1 ? 'spack' : data?.cpId,
								credits: data.credits,
								price: data.price,
								n_responses: data?.n_responses,
								'has-tax': +data.vat_rate > 1,
								defaultPaymentMethod: SOFORT,
								setAsAtu: false,
							};
							$multiPaymentModal.data(settings);
							let modalOptions = credits.generateMultiPaymentModalOptions(
								true,
								data?.credits,
							);
							let nCredits = data?.credits;
							let nResponses = data?.n_responses;

							if (data?.n_responses) {
								const result = await Bark.api('creditpack/large');
								let ppc = null;
								let def = null;
								let advertisedPrice = null;

								if (result?.data) {
									credits.data.largePackData = result.data;
								}

								let largePackData = credits.data.largePackData;
								def = choosePackDefinition(
									largePackData.discount_options,
									data.n_responses,
								);
								ppc = largePackData.price_per_credit / 100;
								advertisedPrice = nCredits * ppc * (1 - def.discount_percent / 100); //ref from price above
								modalOptions = credits.generateMultiPaymentModalOptions(
									true,
									data?.credits,
									ppc,
									advertisedPrice,
								);
							} else {
								let selectPack;
								if (data.is_coupon_applied) {
									let couponCode = data.code;
									const result = await Bark.api(
										'seller/apply-coupon',
										{ code: couponCode },
										(result) => {
											if (result.status) {
												selectPack = result.data.packs.filter((value) => {
													return value.id === data.cpId;
												});
												if (selectPack.length > 0) {
													$multiPaymentModal.data({
														credits: nCredits,
														price: parseFloat(selectPack[0].price_formatted),
														n_responses: nResponses,
														'has-tax': +selectPack[0].vat_rate > 1,
														code: couponCode,
														setAsAtu: setAsAtu,
													});
												}
											}
										},
										() => {},
										'POST',
									);
									modalOptions = credits.generateMultiPaymentModalOptions(
										true,
										nCredits,
										parseFloat(selectPack[0].price_per_credit_formatted),
										selectPack[0].price_formatted,
									);
								} else {
									let cpId = data?.cpId === 1 ? 'spack' : data?.cpId;
									let creditPack = $(`.js-credit-pack-row [data-pack-id=${cpId}]`);
									if (
										$(`[data-pack-id=${cpId}]`).data('atuavail') &&
										$(`[data-pack-id=${cpId}]`)
											.closest('.js-credit-pack-row')
											.find('.atu-container:not(.d-none) .js-atu-toggle')
											.is(':checked')
									) {
										$multiPaymentModal.data({ ...{ setAsAtu: true }, ...settings });
									}
									if (creditPack.length > 0) {
										modalOptions = credits.generateMultiPaymentModalOptions(
											true,
											creditPack.data('credits'),
											creditPack.data('price-per-credit'),
											creditPack.data('pack-price'),
										);
									}
								}
							}

							Bark.hideLoading();
							window.BarkPaymentsCardModal.hideModalErrorText($multiPaymentModal);
							lastPackModalSelector = $multiPaymentModal.attr('id');
							window.BarkPaymentsCardModal.showMultiPaymentModal($multiPaymentModal, {
								...modalOptions,
								...paymentRequest,
							});
							window.BarkPaymentsCardModal.showModalErrorText(
								$multiPaymentModal,
								_t('seller_common:sofort-payment.error.invalid-request'),
							);
							setNewCardLabel();

							return false;
						}
					} catch (e) {
						bugsnagClient.notify(e);
					}
					new Error('Invalid payment intent');
				})
				.catch((err) => {
					//basic error
					console.log(err);
					window.Bark.alertModal(
						_t('seller_common:sofort-payment.error.problem-with-payment'),
					);
					window.bugsnagClient.notify(new Error('Invalid payment intent token'), {
						metaData: {
							err: err,
							errText: 'Invalid payment intent token',
							paymentIntentId: paymentIntentId,
						},
					});
					return false;
				});

			Bark.hideLoading();
		}
	}

	function purchaseLargePack(nResponses, token, paymentIntentId = null) {
		var payload = {
			n_responses: nResponses,
			s_token: token || null,
			tracking: Bark.getTrackableParameters(),
		};

		if (paymentIntentId) {
			payload.paymentIntentId = paymentIntentId;
		}

		if (purchasing) {
			return false;
		}

		purchasing = true;

		Bark.showLoading();

		payload.paymentMethodId = token ? null : primaryPaymentMethod?.id || null;

		Bark.api(
			'creditpack/purchase-large/',
			payload,
			(e) => {
				const sellerInvoiceId = e.data.seller_invoice_id;
				const nCredits = e.data.credits;
				const price = e.data.discounted_price;
				const nResponses = e.data.n_responses;

				largePackPurchaseComplete({
					sellerInvoiceId,
					nCredits,
					price,
					nResponses,
					refreshCard: Boolean(token),
				});
			},
			function (xhr) {
				var error = JSON.parse(xhr.responseText) || {};
				purchasing = false;

				if (error?.error?.type === 'action_required') {
					Bark.hideLoading();
					handleScaAuthenticationRequest(
						error?.error?.error_data?.client_secret,
						(paymentIntent) => {
							purchaseLargePack(nResponses, null, paymentIntent.id);
							getCreditCard();
						},
						isMultiPaymentModalAvailable()
							? (err) => {
									purchasing = false;
									showErrors(err);
							  }
							: null,
					);
				} else {
					handleCardDecline(error);
				}
			},
			'POST',
			Bark.apiVersionHeader('v2'),
		);
	}

	/**
	 * Track a purchase in GA
	 * @param {object} transaction
	 */
	function trackPurchase(transaction) {
		// Handle an inconsistency in the API response
		if (typeof transaction.invoice_id == 'object') {
			transaction.invoice_id = transaction.invoice_id.seller_invoice_id;
		}

		window.ga?.(
			'send',
			'event',
			'purchased_credit_pack',
			transaction.credits + ' credits',
		);

		window.ga?.('ecommerce:addTransaction', {
			id: 'cp_inv_' + transaction.invoice_id,
			affiliation: credits.sellerProfileId,
			revenue: transaction.price,
			shipping: '0',
			tax: '0',
		});

		window.ga?.('ecommerce:addItem', {
			id: 'cp_inv_' + transaction.invoice_id,
			name: transaction.name,
			sku: transaction.name,
			category: transaction.name,
			price: transaction.price,
			quantity: '1',
		});

		window.ga?.('ecommerce:send');
	}

	function trackSubscriptionPurchase(subscription) {
		window.ga?.(
			'send',
			'event',
			'backend',
			'seller_subscribed_elite',
			subscription['label'].toLowerCase(),
		);

		window.ga?.('ecommerce:addTransaction', {
			id: 'elite_' + subscription['id'],
			affiliation: subscription['seller_profile_id'],
			revenue: subscription['price'],
			shipping: '0',
			tax: '0',
		});

		window.ga?.('ecommerce:addItem', {
			id: 'elite_' + subscription['id'],
			name: subscription['name'],
			sku: 'sep_' + subscription['label'],
			category: subscription['label'],
			price: subscription['price'],
			quantity: '1',
		});

		window.ga?.('ecommerce:send');
	}

	/**
	 * Update the amount of credits that the seller has on the page
	 * @param {int} nCredits
	 */
	function updatePageCredits(nCredits) {
		var cur =
			+$('.js-page-n-credits')
				.text()
				.replace(/[^0-9]/g, '') || 0;
		$('.js-page-n-credits').text(_n(nCredits + cur));
	}

	function setNewCardLabel() {
		$("#payment-accordion .card-header [for='new-card']").text(
			_t('seller_common:card-form.debit-credit-card'),
		);
		if (isCardAvailable()) {
			$("#payment-accordion .card-header [for='new-card']").text(
				_t('seller_common:card-form.new-card'),
			);
		}
	}

	/**
	 * Show a pack purchase upsell
	 * @param {int} creditPackId The ID of the credit pack that was just purchased
	 */
	function showPurchasePackUpsell(creditPackId) {
		var pack = getByKey(credits.data.creditPacks, creditPackId);
		var newPack;
		var getNext = false;
		var i;
		var newPrice;
		var oldPrice;

		if (!pack) {
			// Can't do anything
			return;
		}

		for (i = 0; i < credits.data.creditPacks.length; i++) {
			if (getNext) {
				newPack = credits.data.creditPacks[i];
				break;
			}

			if (credits.data.creditPacks[i].id === pack.id) {
				getNext = true;
			}
		}

		if (!newPack) {
			showPurchaseSuccessModal(pack.credits);
			return;
		}

		newPrice = newPack.discounted_price - pack.discounted_price;
		oldPrice = newPack.price - pack.price;

		$('.js-credit-pack-upsell-modal .js-n-credits-purchased').text(_n(pack.credits));
		$('.js-credit-pack-upsell-modal .js-n-extra-credits').text(
			_n(newPack.credits - pack.credits),
		);
		$('.js-credit-pack-upsell-modal .js-extra-discount').text(
			Math.round((1 - newPrice / oldPrice) * 100),
		);
		$('.js-credit-pack-upsell-modal .js-currency-symbol').text('');
		$('.js-credit-pack-upsell-modal .js-old-price').text(currency(oldPrice));
		$('.js-credit-pack-upsell-modal .js-new-price').text(currency(newPrice));
		$('.js-credit-pack-upsell-modal .js-show-vat')[
			pack.vat > 1 || $('#js-show-tax-disclaimers-us').length ? 'removeClass' : 'addClass'
		]('d-none');

		$('#credit-pack-upsell-modal')
			.modal('show')
			.data({
				packId: creditPackId,
				planId: creditPackId,
				packDiscount: newPrice,
				credits: _n(newPack.credits - pack.credits),
				pricePerCredit: newPrice / _n(newPack.credits - pack.credits),
				'has-tax': pack.vat > 1 || $('#js-show-tax-disclaimers-us').length,
				defaultPaymentMethod: isCardAvailable() ? SAVED_CARD : NEW_CARD,
				upsell: true,
			});
	}

	/**
	 * Show a purchase pack success modal
	 * @param {int} n_credits The number of credits that have been purchased
	 */
	function showPurchaseSuccessModal(n_credits) {
		$('.modal').modal('hide');
		$('#credit-pack-purchase-success-modal').modal('show');
		$('.js-credit-pack-purchase-success-modal .js-n-extra-credits').text(
			n_credits ? _n(n_credits) : '',
		);

		QS.deleteValue('payment_intent');
		QS.updateBrowserQuerystring();

		if (redirectAfterSuccess && redirectAfterSuccess === 'Leads') {
			$('#credit-pack-purchase-success-modal').on('hidden.bs.modal', function () {
				Bark.showLoading();
				var projectId = Bark.getUrlParam('prx'),
					url = _l('/sellers/dashboard/' + (projectId ? '?prx=' + projectId : ''));
				location.href = url;
			});
		}
	}

	/**
	 * Convert a number to 2 DP
	 * @param {number} value The number to format
	 * @param {boolean} keepZeroZero [optional] True to keep .00
	 * @returns {number}
	 */
	function to2dp(value, keepZeroZero) {
		var res = Math.ceil(value * 100) / 100;

		if (keepZeroZero) {
			return res;
		}

		return +String(res).replace(/(\.|,)00$/, '');
	}

	function admh(data) {
		var admh = $('#__admh').length ? $('#__admh').val() : null;
		var admsh = $('#__admsh').length ? $('#__admsh').val() : null;

		if (admh && admsh) {
			$.extend(data, {
				admh: admh,
				admsh: admsh,
			});
		}

		return data;
	}

	/**
	 * Purchase a pack with a coupon
	 * @param {string} code The coupon code to use
	 * @param {int} creditPackId The ID of the pack
	 * @param {string|null} token Stripe token
	 * @param {string|null} paymentIntentId
	 */
	function purchaseCouponPack(code, creditPackId, token, paymentIntentId) {
		var payload = {
			code: code,
			cpid: creditPackId,
			stoken: token,
			atuavail: 0,
			atustatus: 0,
			tracking: Bark.getTrackableParameters(),
		};

		if (setAsAtu) {
			payload.atuavail = 1;
			payload.atustatus = 1;
		}

		if (paymentIntentId) {
			payload.paymentIntentId = paymentIntentId;
		}

		if (purchasing) {
			return;
		}

		purchasing = true;

		payload = admh(payload);

		var pack = getByKey(credits.data.creditPacks, creditPackId);

		Bark.showLoading();

		payload.paymentMethodId = token ? null : primaryPaymentMethod?.id || null;

		Bark.api(
			'seller/purchase-with-coupon',
			payload,
			(e) => {
				const nCredits = e.data.credits + e.data.free_credits;
				const sellerInvoiceId = e.data.seller_invoice_id;
				const price = e.data.price;

				couponPackPurchaseComplete({
					nCredits,
					sellerInvoiceId,
					price,
					status: e.status,
					refreshCard: Boolean(token),
					creditPackId,
				});
			},
			function (xhr) {
				var error = JSON.parse(xhr.responseText) || {};
				purchasing = false;

				if (error?.error?.type === 'action_required') {
					Bark.hideLoading();
					handleScaAuthenticationRequest(
						error?.error?.error_data?.client_secret,
						(paymentIntent) => {
							purchaseCouponPack(code, creditPackId, null, paymentIntent.id);
							getCreditCard();
						},
						isMultiPaymentModalAvailable()
							? (err) => {
									purchasing = false;
									showErrors(err);
							  }
							: null,
					);
				} else {
					if (xhr.status == 422) {
						showErrors({}, false, _t('seller_settings_credits:errors.adding-to-account'));
					} else {
						handleCardDecline(error);
					}
				}

				return false;
			},
			'POST',
			Bark.apiVersionHeader('v2'),
		);
	}

	function handleCardDecline(error) {
		sellerRetryAttempts += 1;
		Bark.hideLoading();

		var errorReason;
		if (typeof error.decline_reason !== 'undefined') {
			errorReason = error.decline_reason;
		} else {
			errorReason = {
				conversational_error_message: _t('seller_common:card-error.general-error'),
				clean_error_message: _t('seller_common:card-error.secondary-error'),
				user_action_message: _t('seller_common:card-error.contact-issuer'),
				primary_cta_text: _t('seller_common:card-error.use-a-different-card'),
				user_can_try_again: 0,
				recoverable_decline: 1,
			};
		}

		if (primaryPaymentMethod?.card_number) {
			errorReason.conversational_error_message = _t(
				'seller_common:card-error.general-error-last-four',
				{
					card_last_four: primaryPaymentMethod?.card_number,
				},
			);
			errorReason.clean_error_message = _t(
				'seller_common:card-error.secondary-error-last-four',
				{
					card_last_four: primaryPaymentMethod?.card_number,
				},
			);
		}

		isMultiPaymentModalAvailable() &&
			creditCardTracking.logAction('payment failure', {
				payment_method: $('#payment-accordion .collapse.open').data('payment-method'),
			});

		// if the seller has already tried to update their card details
		if (sellerRetryAttempts > 1) {
			var errorText = Bark.ucfirst(errorReason.clean_error_message) + '. ';
			errorText += _t('seller_common:card-error.contact-issuer-followup');
			// send them back to the card update screen with an error message
			cardModalOptions = null;
			if (isMultiPaymentModalAvailable()) {
				window.BarkPaymentsCardModal.showModalErrorText($multiPaymentModal, errorText);
				lastPackModalSelector = $multiPaymentModal.attr('id');
				window.BarkPaymentsCardModal.showMultiPaymentModal(
					$multiPaymentModal,
					paymentRequest,
				);
			} else {
				window.BarkPaymentsCardModal.showModalErrorText($cardModal, errorText);
				lastPackModalSelector = $cardModal.attr('id');
				window.BarkPaymentsCardModal.showCardModal($cardModal, paymentRequest);
			}
		} else {
			$('.js-purchase-credits-error-heading').text(
				_t('seller_settings_credits:errors.credit-purchase-failed'),
			);
			$('.js-card-decline-reason').text(errorReason.conversational_error_message);
			$('.js-card-decline-user-action').text(errorReason.user_action_message);
			$('.js-reenter-card-details').text(errorReason.primary_cta_text);
			$('#purchaseCreditsError').modal('show');
		}
	}

	/**
	 * Register a new card on Stripe
	 * @param {string} tokenId
	 */
	function registerNewCard(tokenId) {
		Bark.showLoading();
		window.BarkPaymentsCardModal.confirmSetupIntent($cardModal.data('user-id'), tokenId)
			.then(async () => {
				Bark.hideLoading();
				await getCreditCard();
			})
			.catch((e) => {
				const error = handleErrors(
					e?.error || {},
					_t('seller_settings_credits:errors.problem-with-card'),
				);
				Bark.hideLoading();
				cardModalOptions = null;
				window.BarkPaymentsCardModal.showModalErrorText($cardModal, error.message);
				lastPackModalSelector = $cardModal.attr('id');
				window.BarkPaymentsCardModal.showCardModal($cardModal);
			});
	}

	function getModalOptions(credits = null, pricePerCredit = null, packPrice = null) {
		let headerText =
			credits != null
				? _t('seller_settings_credits:credit-upsell-modal.purchase-details.header', {
						total_credits: credits,
				  })
				: '';

		let subheaderHtml = _t(
			'seller_settings_credits:credit-upsell-modal.amount-summary.title',
			{
				each_amount:
					pricePerCredit != null
						? _t(
								'seller_settings_credits:credit-upsell-modal.amount-summary.each-amount',
								{ price_per_credit: currency(pricePerCredit) },
						  )
						: '',
				total_amount: _t(
					'seller_settings_credits:credit-upsell-modal.amount-summary.total-amount',
					{ total_price: currency(packPrice) },
				),
				excluding_vat: window.BarkPaymentsCardModal.hasTax($multiPaymentModal)
					? _t('common:excluding-vat-text')
					: '',
			},
		);
		return {
			headerText: headerText,
			subheaderHtml: subheaderHtml,
			confirmText: _t('seller_settings_credits:payment-card-modal.purchase-button'),
			clearModal: true,
		};
	}

	function triggerPurchase(
		scope,
		planId,
		nCredits,
		packDiscount,
		pricePerCredit,
		hasTax,
		atuAvail,
	) {
		if (purchasing) {
			return false;
		}

		currentPurchaseId = planId;
		setAsAtu = false;
		cardFormAction = 'purchase';

		const pack = getByKey(window.Bark.credits.data.creditPacks, planId);
		paymentRequest = generateWalletOptions(true, {
			amount: pack.discounted_price * 100,
			isUpsell: false,
			cpId: planId,
			packType: 'credit-pack',
			userId: Bark.USER.userId,
			onWalletPaymentComplete: async (
				_,
				__,
				initPaymentIntentResponse,
				___,
				paymentMethodType,
			) => {
				packPurchaseComplete({
					sellerInvoiceId: initPaymentIntentResponse.invoiceId,
					creditPackId: planId,
					setAsAutoTopup: setAsAtu && paymentMethodType !== 'paypal',
					showUpsell: paymentMethodType !== 'paypal',
					refreshCard: true,
				});
				paymentRequest = {};
			},
		});

		if (atuAvail) {
			setAsAtu = +$('.js-atu-toggle:visible', scope.parent().parent())[0].checked;
		}

		$('.js-add-new-card-title').removeClass('d-none');
		$('.js-update-card-title').addClass('d-none');
		$('.js-payment-card-purchase-text').text('Purchase');

		if (isMultiPaymentModalAvailable()) {
			if (primaryPaymentMethod?.id) {
				showSavedCardIfAvailable();
			}
			$multiPaymentModal.data({
				planId: planId,
				credits: nCredits,
				packDiscount: packDiscount,
				pricePerCredit: pricePerCredit,
				'has-tax': hasTax,
				'pack-type': 'credit',
				upsell: false,
				'upsell-card': true,
				n_responses: null,
				defaultPaymentMethod: isCardAvailable() ? SAVED_CARD : NEW_CARD,
				setAsAtu: setAsAtu,
			});

			let modalOptions =
				planId === 'spack'
					? getModalOptions(nCredits, pricePerCredit, packDiscount)
					: {
							headerText: _t('seller_common:card-form.default-title'),
							subheaderHtml: '',
							clearModal: true,
					  };

			if ($('#atu-purchase-single-pack').is(':visible')) {
				$('#atu-purchase-single-pack').modal('hide');
			}

			lastPackModalSelector = $multiPaymentModal.attr('id');
			window.BarkPaymentsCardModal.showMultiPaymentModal($multiPaymentModal, {
				...modalOptions,
				...paymentRequest,
			});
			setNewCardLabel();
			return;
		}

		if (!primaryPaymentMethod?.id) {
			var openModals = $('.modal.show');
			if (openModals.length > 0) {
				openModals.modal('hide');
			}
			cardModalOptions = {
				headerText: _t('seller_settings_credits:payment-card-modal.add-new-card-title'),
				confirmText: _t('seller_settings_credits:payment-card-modal.purchase-button'),
				clearModal: true,
				...paymentRequest,
			};
			lastPackModalSelector = $cardModal.attr('id');
			window.BarkPaymentsCardModal.showCardModal($cardModal, cardModalOptions);
			return;
		}

		if ($('#atu-purchase-single-pack').is(':visible')) {
			$('#atu-purchase-single-pack').modal('hide');
		}

		purchaseCredits(currentPurchaseId, setAsAtu);
	}

	function triggerPurchaseWithCoupon(
		currentPurchaseId,
		credits,
		pricePerCredit,
		packPrice,
		setAsAtu,
	) {
		const couponCode = $('#coupon-code').val().trim();
		cardFormAction = 'coupon';

		if (isCardAvailable()) {
			if (isMultiPaymentModalAvailable()) {
				showSavedCardIfAvailable();
			} else {
				purchaseCouponPack(couponCode, currentPurchaseId);
				return;
			}
		}

		paymentRequest = generateWalletOptions(true, {
			amount: packPrice * 100,
			isUpsell: false,
			cpId: currentPurchaseId,
			code: couponCode,
			packType: 'coupon',
			userId: Bark.USER.userId,
			onWalletPaymentComplete: async (_, __, initPaymentIntentResponse) => {
				couponPackPurchaseComplete({
					nCredits: initPaymentIntentResponse.nCredits,
					sellerInvoiceId: initPaymentIntentResponse.invoiceId,
					price: initPaymentIntentResponse.price,
					status: true,
					refreshCard: true,
					creditPackId: currentPurchaseId,
				});
				paymentRequest = {};
			},
		});

		if (isMultiPaymentModalAvailable()) {
			$multiPaymentModal.data({
				'plan-id': currentPurchaseId,
				'has-tax': true,
				code: couponCode,
				'pack-type': 'coupon',
				setAsAtu: setAsAtu,
				n_responses: null,
			});
			let modalOptions = getModalOptions(credits, pricePerCredit, packPrice);

			lastPackModalSelector = $multiPaymentModal.attr('id');
			window.BarkPaymentsCardModal.showMultiPaymentModal($multiPaymentModal, {
				...modalOptions,
				...paymentRequest,
			});
			setNewCardLabel();
		} else {
			cardModalOptions = {
				headerText: _t('seller_settings_credits:payment-card-modal.add-new-card-title'),
				confirmText: _t('seller_settings_credits:payment-card-modal.purchase-button'),
				clearModal: true,
				...paymentRequest,
			};
			window.BarkPaymentsCardModal.showCardModal($cardModal, cardModalOptions);
		}
	}

	function triggerPurchaseLargePack() {
		cardFormAction = 'large_pack';
		setAsAtu = false;

		$('.js-add-new-card-title').addClass('d-none');
		$('.js-update-card-title').removeClass('d-none');
		$('.js-payment-card-purchase-text').text('Purchase');

		$('#large-pack-modal').modal('hide');

		if (!primaryPaymentMethod?.id) {
			getCreditCard();
		}

		if (primaryPaymentMethod?.id) {
			if (isMultiPaymentModalAvailable()) {
				showSavedCardIfAvailable();
			} else {
				purchaseLargePack(Number($('#large-pack-modal .js-range-slider').val()));
				return;
			}
		}

		const nResponses = $('#large-pack-modal .js-range-slider').val();
		const largePackData = credits.data.largePackData;
		const def = choosePackDefinition(largePackData.discount_options, nResponses);
		const nCredits = nResponses * largePackData.base_credits_per_response;
		const ppc = largePackData.price_per_credit / 100;
		const advertisedPrice = nCredits * ppc * (1 - def.discount_percent / 100); //ref from price above

		paymentRequest = generateWalletOptions(true, {
			amount: advertisedPrice * 100,
			isUpsell: false,
			packType: 'large',
			userId: Bark.USER.userId,
			nResponses,
			onWalletPaymentComplete: async (_, __, initPaymentIntentResponse) => {
				largePackPurchaseComplete({
					nCredits,
					nResponses,
					sellerInvoiceId: initPaymentIntentResponse.invoiceId,
					price: advertisedPrice,
					refreshCard: true,
				});
				paymentRequest = {};
			},
		});

		if (isMultiPaymentModalAvailable()) {
			let nResponses = $('#large-pack-modal .js-range-slider').val();

			$multiPaymentModal.data({
				planId: null,
				n_responses: nResponses,
				'has-tax': true,
				'pack-type': 'large',
				setAsAtu: setAsAtu,
				defaultPaymentMethod: isCardAvailable() ? SAVED_CARD : NEW_CARD,
			});

			let modalOptions = getModalOptions(nCredits, ppc, advertisedPrice);

			lastPackModalSelector = $multiPaymentModal.attr('id');
			window.BarkPaymentsCardModal.showMultiPaymentModal($multiPaymentModal, {
				...modalOptions,
				...paymentRequest,
			});
			setNewCardLabel();
		} else {
			cardModalOptions = {
				headerText: _t('seller_settings_credits:payment-card-modal.add-new-card-title'),
				confirmText: _t('seller_settings_credits:payment-card-modal.purchase-button'),
				clearModal: true,
				...paymentRequest,
			};
			lastPackModalSelector = $cardModal.attr('id');
			window.BarkPaymentsCardModal.showCardModal($cardModal, cardModalOptions);
		}
	}

	function openUSTaxCompliantModal(data, context = 'Purchase credits (my credits page)') {
		if ($('#atu-purchase-single-pack').is(':visible')) {
			$('#atu-purchase-single-pack').modal('hide');
		}
		if (isMultiPaymentModalAvailable() || !primaryPaymentMethod?.id) {
			$('#next-button-business-address').removeClass('btn-success');
			$('#next-button-business-address').addClass('btn-primary');
		} else {
			$('#next-button-business-address').html(
				_t('seller_settings_credits:us-tax-compliance.buy-credits-confirm-button'),
			);
		}
		$('#addressCompliance').data(data).modal('show');
		$('.js-close-business-address-modal').removeClass('d-none');
		tracking('Wayfair', `US Tax Compliance - ` + context + ` begin`, {
			context: context,
		});
		continueToBusinessAddress(context);
	}

	function bindUSTaxComplianceNextAction($callback) {
		$('#next-button-business-address')
			.off('click')
			.on('click', async function () {
				Bark.logEvent('click', 'next button business address');
				if (isUSTaxComplianceActive()) {
					Bark.showLoading();
					saveBusinessAddress('Purchase credits (my credits page)', function () {
						USTaxCompliantStatus = true;
						let $container = $('#addressCompliance');
						$container.modal('hide');
						Bark.hideLoading();
						$callback();
					});
				}
			});
	}

	/**
	 * Bind buttons to click purchase
	 */
	function bindPurchaseHandler() {
		$('.js-purchase-pack')
			.off('click.purchasepack')
			.on('click.purchasepack', function () {
				var t = $(this);
				var scope = t.parent();
				if (isUSTaxComplianceActive() && !USTaxCompliantStatus) {
					let $callback = function () {
						triggerPurchase(
							scope,
							t.data('pack-id'),
							t.data('credits'),
							t.data('pack-price'),
							t.data('price-per-credit'),
							t.data('has-tax'),
							t.data('atuavail'),
						);
					};
					openUSTaxCompliantModal({});
					bindUSTaxComplianceNextAction($callback);
				} else {
					triggerPurchase(
						scope,
						t.data('pack-id'),
						t.data('credits'),
						t.data('pack-price'),
						t.data('price-per-credit'),
						t.data('has-tax'),
						t.data('atuavail'),
					);
				}
			});
	}

	(credits.generateMultiPaymentModalOptions = function (
		showPurchaseDetails,
		totalCredits,
		ppc,
		totalPack,
	) {
		const modalOptions = {};
		modalOptions['headerText'] = _t('seller_common:sofort-payment.payment-method-title');
		modalOptions['subheaderHtml'] = '';

		if (showPurchaseDetails) {
			if (totalCredits) {
				modalOptions['headerText'] = _t(
					'seller_settings_credits:credit-upsell-modal.purchase-details-alt.header',
					{ total_credits: totalCredits },
				);
			}
			if (ppc && totalPack) {
				modalOptions['subheaderHtml'] = _t(
					'seller_settings_credits:credit-upsell-modal.amount-summary-alt.title',
					{
						each_amount:
							ppc !== null
								? _t(
										'seller_settings_credits:credit-upsell-modal.amount-summary-alt.each-amount',
										{ price_per_credit: currency(ppc) },
								  )
								: '',
						total_amount: _t(
							'seller_settings_credits:credit-upsell-modal.amount-summary-alt.total-amount',
							{ total_price: currency(totalPack) },
						),
						excluding_vat: window.BarkPaymentsCardModal.hasTax($multiPaymentModal)
							? _t('common:excluding-vat-text')
							: '',
					},
				);
			}
		}
		return modalOptions;
	}),
		/**
		 * Get credit packs for the current seller
		 */
		(credits.getCreditPacks = function () {
			if (pendingAjax.credits) {
				return;
			}

			pendingAjax.credits = true;

			$('#my_credits').addClass('waiting');

			$('.js-starter-pack-container').addClass('d-none');
			$('.js-credit-packs-container').addClass('d-none');

			Bark.api(
				'creditpacks',
				null,
				function (e) {
					pendingAjax.credits = false;
					credits.data.creditPacks = e.data;
					renderCreditPacks(credits.data.creditPacks);
					$('#my_credits').removeClass('waiting');
				},
				function (err) {
					showErrors(err);
				},
			);
		});

	/**
	 * Get the transaction log
	 */
	credits.getTransactionLog = function () {
		var pn =
			Math.floor(credits.data.transactions.length / paginationItems) * paginationItems +
			1;

		if (pendingAjax.transactions) {
			return;
		}

		pendingAjax.transactions = true;
		$('#credit-transaction-table').addClass('waiting');

		if (!credits.data.transactions.length) {
			$('.js-credit-transaction-table .js-pseudo-body').empty();
		}

		Bark.api(
			'seller/transactions/' + pn,
			null,
			function (e) {
				if (e.status) {
					pendingAjax.transactions = false;
					$('#credit-transaction-table').removeClass('waiting');
					credits.data.transactions = credits.data.transactions.concat(
						e.data.transactions,
					);

					appendToTransactions(e.data.transactions);
					paginationManager.output(
						'#credit-transaction-pagination',
						e.data.last_page,
						e.data.current_page,
						function (e) {
							credits.getTransactionLogFromPage(e);
						},
					);
				} else {
					$('#credit-transaction-table').removeClass('waiting');
					showErrors(
						e,
						false,
						_t('seller_settings_credits:credit-transaction-log.fetch-error'),
					);
				}
				$('#credit-transaction-table').css(
					'min-height',
					$('#credit-transaction-table').height(),
				);
			},
			function (err) {
				$('#credit-transaction-table').removeClass('waiting');
				showErrors(err);
			},
			'GET',
			Bark.apiVersionHeader('v2'),
		);
	};
	credits.getTransactionLogFromPage = function (pn) {
		if (pendingAjax.transactions || $('#credit-transaction-table').hasClass('waiting')) {
			return;
		}
		$('#credit-transaction-table').addClass('waiting');
		pendingAjax.transactions = true;
		quickScroll($('.js-credit-transactions-section'), -80);
		$('.js-credit-transaction-table .js-pseudo-body').empty();
		Bark.api(
			'seller/transactions/' + pn,
			null,
			function (e) {
				if (e.status) {
					pendingAjax.transactions = false;

					credits.data.transactions = credits.data.transactions.concat(
						e.data.transactions,
					);

					appendToTransactions(e.data.transactions);
					$('#credit-transaction-table').css('min-height', 'initial');
					$('#credit-transaction-table').removeClass('waiting');
					$('#credit-transaction-table').css(
						'min-height',
						$('#credit-transaction-table').height(),
					);
					paginationManager.output(
						'#credit-transaction-pagination',
						e.data.last_page,
						e.data.current_page,
						function (e) {
							credits.getTransactionLogFromPage(e);
						},
					);
				} else {
					$('#credit-transaction-table').removeClass('waiting');
					showErrors(
						e,
						false,
						_t('seller_settings_credits:credit-transaction-log.page-fetch-error'),
					);
				}
			},
			function (err) {
				$('#credit-transaction-table').removeClass('waiting');
				showErrors(err);
			},
			'GET',
			Bark.apiVersionHeader('v2'),
		);
	};

	/**
	 * Get the free responses for a seller
	 */
	credits.getFreeResponses = function () {
		var payload;

		if (pendingAjax.freeResponses || !allowCheckFreeResponses) {
			return;
		}

		pendingAjax.freeResponses = true;

		if (!credits.data.freeResponses.length) {
			$('.js-free-responses-table .js-pseudo-body').empty();
		}

		payload = { start_at: credits.data.freeResponses.length, limit: paginationItems };

		// @todo add a loader

		Bark.api(
			'seller/pfree-responses',
			payload,
			function (e) {
				pendingAjax.freeResponses = false;

				if ((e.data || []).length) {
					credits.data.freeResponses = credits.data.freeResponses.concat(e.data);

					allowCheckFreeResponses = e.data.length === paginationItems;

					appendToFreeResponses(e.data);
				} else {
					allowCheckFreeResponses = false;
				}
			},
			function (err) {
				showErrors(err);
			},
		);
	};

	/**
	 * Close the partnerships callout
	 */
	const closeCallout = () => {
		let lpData = credits.data.largePackData;

		togglePartnershipsCallout(lpData.base_credits_per_response, lpData.value_min);
	};

	const purchaseUpsell = (packId, paymentIntentId = null) => {
		const payload = {
			cpid: packId,
			tracking: Bark.getTrackableParameters(),
		};

		paymentRequest = {};

		if (paymentIntentId) {
			payload.payment_intent_id = paymentIntentId;
		}

		cardFormAction = 'purchase-upsell';
		currentUpsellId = packId;

		Bark.showLoading();

		payload.paymentMethodId = primaryPaymentMethod?.id || null;

		Bark.api(
			'creditpack/purchase-upsell',
			payload,
			function (e) {
				$('.js-purchase-upsell-pack').removeAttr('disabled');

				Bark.hideLoading();
				$('#credit-pack-upsell-modal').modal('hide');

				if (e.hasOwnProperty('credits_purchased')) {
					showPurchaseSuccessModal(e.credits_purchased);
				} else if (e.hasOwnProperty('data') && e.data.hasOwnProperty('credits')) {
					showPurchaseSuccessModal(e.data.credits);
				} else {
					showPurchaseSuccessModal(false);
				}

				updatePageCredits(e.data.credits);

				trackPurchase({
					invoice_id: e.data.seller_invoice_id,
					credits: e.data.credits,
					price: e.data.price,
					name: 'UpsellPack',
				});
			},
			function (err) {
				const errorResponse = err.responseJSON;
				purchasing = false;
				$('.js-purchase-upsell-pack').removeAttr('disabled');

				Bark.hideLoading();

				if (errorResponse?.error?.type === 'action_required') {
					$('#credit-pack-upsell-modal').modal('hide');

					handleScaAuthenticationRequest(
						errorResponse?.error?.error_data?.client_secret,
						(paymentIntent) => {
							purchasing = false;
							purchaseUpsell(packId, paymentIntent.id);
							getCreditCard();
						},
						() => {
							purchasing = false;
							showErrors(err);
						},
					);
				} else {
					showErrors(err);
					isMultiPaymentModalAvailable() &&
						creditCardTracking.logAction('payment failure', {
							payment_method: $('#payment-accordion .collapse.open').data(
								'payment-method',
							),
						});
				}
			},
			'POST',
		);
	};

	function showSavedCardIfAvailable() {
		if (!primaryPaymentMethod?.id) {
			return;
		}
		$('.response-modal-card-number-suffix').text(primaryPaymentMethod.card_number);
		$('.response-modal-card-expiry-date').text(
			`${
				primaryPaymentMethod.card_expiry_month
			}/${primaryPaymentMethod.card_expiry_year.slice(-2)}`,
		);
		$('.response-modal-card-brand-name').text(primaryPaymentMethod.card_brand);
		$('.response-modal-card-brand')
			.empty()
			.append(
				$('<img>', {
					class: 'img-fluid',
					src: primaryPaymentMethod.card_brand_image,
				}),
			);
		$('.js-saved-card').removeClass('d-none');
		$('.js-card-details-row').removeClass('d-none');
	}

	$(function () {
		paginationManager = new PaginationManager();
		loadPage();

		$('.js-credit-transaction-table .js-pseudo-body')
			.off('scroll.listen')
			.on('scroll.listen', function () {
				if ($('.js-credit-transaction-table .js-pseudo-tr:last').isVisibleInParent(100)) {
					credits.getTransactionLog();
				}
			});

		$('.js-free-responses-table .js-pseudo-body')
			.off('scroll.listen')
			.on('scroll.listen', function () {
				if ($('.js-free-responses-table .js-pseudo-tr:last').isVisibleInParent(100)) {
					credits.getFreeResponses();
				}
			});

		$('.js-turn-off-atu')
			.off('click.atu-off')
			.on('click.atu-off', function () {
				$('#turn-off-atu-modal').modal('hide');

				Bark.showLoading();

				Bark.api(
					'seller/autotopup-status',
					{ status: 0 },
					function () {
						credits.data.creditPacks = [];

						credits.getCreditPacks();
						Bark.hideLoading();
					},
					function (err) {
						showErrors(err);
					},
					'POST',
				);
			});

		$('.js-open-purchase-single-pack-modal')
			.off('click.openmodal')
			.on('click.openmodal', function () {
				var i;
				var cur;

				$('.js-single-purchase-pack-container').empty();

				if (!credits.templates.singlePurchasePackRow) {
					credits.templates.singlePurchasePackRow = Handlebars.compile(
						document.getElementById('handlebars-single-purchase-pack-row').innerHTML,
					);
				}

				for (i = 0; i < credits.data.creditPacks.length; i++) {
					cur = credits.data.creditPacks[i];

					$('.js-single-purchase-pack-container').append(
						credits.templates.singlePurchasePackRow({
							pack_id: cur.id,
							estimated_responses: cur.responses,
							estimated_responses_text: _t(
								'seller_settings_credits:credit-pack-template.estimated-number-of-responses',
								{
									number_of_starter_pack_responses: _n(cur.responses),
								},
							),
							total_credits: cur.credits,
							n_credits: _n(cur.credits),
							n_credits_text: _t(
								'seller_settings_credits:credit-pack-template.total-credits-in-pack',
								{
									total_credits: _n(cur.credits),
								},
							),
							pack_price: currency(cur.discounted_price),
							pack_price_value: cur.discounted_price,
							has_vat: +cur.vat > 1 || $('#js-show-tax-disclaimers-us').length,
							price_per_credit: currency(cur.price_per_credit),
							price_per_credit_value: cur.price_per_credit,
							price_per_credit_text: _t(
								'seller_settings_credits:credit-pack-template.price-per-credit-in-pack',
								{
									price_per_credit: currency(cur.price_per_credit),
								},
							),
							is_best_value: i + 1 === credits.data.creditPacks.length,
							discount: _n(cur.discount),
							has_discount: cur.discount !== 0,
							discount_text: _t(
								'seller_settings_credits:credit-pack-template.discount-percent',
								{
									discount_percent: _n(cur.discount),
								},
							),
						}),
					);
				}

				bindPurchaseHandler();
				$('#atu-purchase-single-pack').modal('show');
			});

		$('.js-submit-coupon')
			.off('click.submit-coupon')
			.on('click.submit-coupon', function () {
				submitCoupon($('#coupon-code').val().trim());
			});

		$('#coupon-code')
			.off('keypress.submit-coupon')
			.on('keypress.submit-coupon', function (e) {
				if (e.keyCode === KEY_CODE_ENTER) {
					submitCoupon((this.value || '').trim());
				}
			});
		$('.js-close-success-modal')
			.off('click.navigate')
			.on('click.navigate', function () {
				$('.modal').modal('hide');
				Bark.hideLoading();
			});
		$('.js-change-card')
			.off('click.changecard')
			.on('click.changecard', function () {
				cardFormAction = 'change';
				cardModalOptions = {
					headerText: _t('seller_settings_credits:payment-card-modal.update-title'),
					confirmText: _t('seller_settings_credits:payment-card-modal.update-button'),
					clearModal: true,
					enableWallets: true,
					paymentOptions: {
						isOnlySavingCard: true,
						userId: Bark.USER.userId,
						disableWallets: {
							paypal: true,
						},
						onWalletSetupComplete: async () => {
							await getCreditCard();
						},
					},
				};
				lastPackModalSelector = $cardModal.attr('id');
				window.BarkPaymentsCardModal.showCardModal($cardModal, cardModalOptions);
			});

		$('#free-response-toggle')
			.off('change.toggle')
			.on('change.toggle', function () {
				var t = this;
				t.disabled = true;

				Bark.api(
					'seller/toggle-free-response',
					{ enabled: +t.checked },
					function () {
						t.disabled = false;
						setFreeResponseToggleText(t.checked);
					},
					function (err) {
						showErrors(err);
					},
					'POST',
				);
			});

		$('.js-purchase-upsell-pack')
			.off('click.purchaseupsell')
			.on('click.purchaseupsell', async function () {
				var t = $(this);
				const $creditPackUpsellPack = $('#credit-pack-upsell-modal');
				var packId = $creditPackUpsellPack.data('packId');

				if (!packId) {
					$creditPackUpsellPack.modal('hide');
					Bark.alertModal(_t('seller_settings_credits:errors.purchase-failed'));
					return;
				}

				if (t.attr('disabled')) {
					return;
				}

				paymentRequest = {};

				t.attr({ disabled: 'disabled' });

				if (isMultiPaymentModalAvailable()) {
					$('.js-card-details-row').addClass('d-none');
					primaryPaymentMethod = await getPrimaryPaymentMethod(sellerProfileId);
					showSavedCardIfAvailable();

					$(this).closest('.modal').modal('hide');
					cardFormAction = 'purchase-upsell';
					const $creditPackUpsellPack = $('#credit-pack-upsell-modal');
					const { planId, credits, packDiscount, pricePerCredit } =
						$creditPackUpsellPack.data();
					$multiPaymentModal.data({
						planId: planId,
						'pack-type': 'credit-pack',
						credits: t.data('credits'),
						packDiscount: t.data('packDiscount'),
						'has-tax': t.data('has-tax'),
						defaultPaymentMethod: isCardAvailable() ? SAVED_CARD : NEW_CARD,
						upsell: true,
						'upsell-card': false,
						n_responses: null,
						setAsAtu: setAsAtu,
					});

					let modalOptions = getModalOptions(credits, pricePerCredit, packDiscount);
					lastPackModalSelector = $multiPaymentModal.attr('id');
					window.BarkPaymentsCardModal.showMultiPaymentModal(
						$multiPaymentModal,
						modalOptions,
					);
					setNewCardLabel();
					t.removeAttr('disabled');
				} else {
					purchaseUpsell(packId);
				}
			});

		$('.js-reenter-card-details')
			.off('click')
			.on('click', function () {
				$(this).closest('.modal').modal('hide');
				cardModalOptions = null;
				if (isMultiPaymentModalAvailable()) {
					$(this).closest('.modal').modal('hide');
					const $creditPackUpsellPack = $('#credit-pack-upsell-modal');
					let { credits, packDiscount, pricePerCredit } = $multiPaymentModal.data();
					let modalOptions = getModalOptions(credits, pricePerCredit, packDiscount);
					lastPackModalSelector = $multiPaymentModal.attr('id');
					window.BarkPaymentsCardModal.showMultiPaymentModal($multiPaymentModal, {
						resetFormAfterFailedSCA: true,
						...modalOptions,
						...paymentRequest,
					});
					setNewCardLabel();
				} else {
					lastPackModalSelector = $cardModal.attr('id');
					window.BarkPaymentsCardModal.showCardModal($cardModal, paymentRequest);
				}
			});

		$('.js-trigger-large-pack-modal')
			.off('click.large-pack-open')
			.on('click.large-pack-open', function () {
				var msg;

				if (credits.data.largePackData) {
					displayLargePack(credits.data.largePackData, largePackDefaultResponse);
					return;
				}

				Bark.showLoading();

				Bark.api(
					'creditpack/large',
					null,
					function (e) {
						Bark.hideLoading();

						if (!e.status) {
							msg = _t('seller_settings_credits:errors.generic-request-failed');

							if ((e.error || {}).message === 'Not available') {
								msg = _t('seller_settings_credits:errors.starter-pack-required-first');
							}

							showErrors({ message: msg }, false, msg);
							return;
						}

						$('#large-pack-modal').modal('show');

						credits.data.largePackData = e.data;

						displayLargePack(e.data, largePackDefaultResponse);
					},
					function () {
						showErrors({
							message: _t('seller_settings_credits:errors.generic-request-failed'),
						});
					},
				);
			});

		$('.js-trigger-larger-credit-pack-discount-ts-and-cs-modal')
			.off('click.larger-credit-pack-discount-ts-and-cs-modal-open')
			.on('click.larger-credit-pack-discount-ts-and-cs-modal-open', function () {
				$('#larger-credit-pack-discount-ts-and-cs-modal').modal('show');
			});

		$('.js-close-larger-credit-pack-discount-ts-and-cs-modal')
			.off('click.larger-credit-pack-discount-ts-and-cs-modal-close')
			.on('click.larger-credit-pack-discount-ts-and-cs-modal-close', function () {
				$('#larger-credit-pack-discount-ts-and-cs-modal').modal('hide');
			});

		$('.js-purchase-large-pack')
			.off('click.buy-large-pack')
			.on('click.buy-large-pack', function () {
				if (isUSTaxComplianceActive() && !USTaxCompliantStatus) {
					let $callback = function () {
						triggerPurchaseLargePack();
					};
					$('#large-pack-modal').modal('hide');
					openUSTaxCompliantModal({}, 'Credit pack slider');
					bindUSTaxComplianceNextAction($callback);
				} else {
					triggerPurchaseLargePack();
				}
			});

		if ($('#coupon-code').val().length > 0) {
			$('.js-submit-coupon').trigger('click.submit-coupon');
		}

		if (+Bark.GET('lpd')) {
			largePackDefaultResponse = Bark.GET('lpd');
		}

		if (+Bark.GET('lp')) {
			$('.js-trigger-large-pack-modal').click();
		}

		$('.js-large-pack-request-callback')
			.off('click.callbackRequest')
			.on('click.callbackRequest', function () {
				$.post('/api/elo/', {
					c: 'large-pack-callback-request',
					n: 'click',
					i: 'modal_open',
				});

				$('.modal').modal('hide');

				$('.js-callback-error-container').addClass('d-none');
				$('#large-pack-callback-name').val((credits.self || {}).seller_name || '');
				$('#large-pack-callback-tel').val((credits.self || {}).telephone || '');

				$('#large-pack-callback-modal').modal('show');
			});

		$('.js-large-pack-submit-callback-request')
			.off('click.submitRequest')
			.on('click.submitRequest', function () {
				var t = $(this);
				var spinner = $('.js-large-pack-callback-spinner');
				var payload = {
					name: $('#large-pack-callback-name').val(),
					tel: $('#large-pack-callback-tel').val(),
					n_responses: creditsInfo.n_responses,
					base_credits_per_response: creditsInfo.base_credits_per_response,
					advertised_price: creditsInfo.advertised_price,
					advertised_discount: creditsInfo.advertised_discount,
				};

				if (!payload.name) {
					showCallbackError(
						_t(
							'seller_settings_credits:large-pack-purchase.request-callback.form.name-error',
						),
					);
					return;
				}

				$.post('/api/elo/', { c: 'large-pack-callback-request', n: 'submit' });

				t.addClass('d-none');
				spinner.removeClass('d-none');

				Bark.validate.ukTel(
					payload.tel,
					function (success, moderate) {
						if (success || (!success && moderate)) {
							Bark.api(
								'creditpack/large/callback',
								payload,
								(e) => {
									t.removeClass('d-none');
									spinner.addClass('d-none');

									if (e.status) {
										// Show success modal
										$.post('/api/elo/', {
											c: 'large-pack-callback-request',
											n: 'submit',
											i: 'success',
										});
										$('.modal').modal('hide');
										$('#large-pack-callback-modal-success').modal('show');
										window.setTimeout(() => {
											$('#large-pack-callback-modal-success').modal('hide');
											closeCallout();
										}, 3000);
										return;
									}

									$.post('/api/elo/', {
										c: 'large-pack-callback-request',
										n: 'submit',
										i: 'fail',
									});

									showCallbackError(
										_t(
											'seller_settings_credits:large-pack-purchase.request-callback.form.generic-error',
										),
									);
								},
								(e) => {
									let error = JSON.parse(e.responseText) || {};

									t.removeClass('d-none');
									spinner.addClass('d-none');

									$.post('/api/elo/', {
										c: 'large-pack-callback-request',
										n: 'submit',
										i: 'fail',
									});
									showCallbackError(
										error.message ||
											_t('seller_settings_credits:errors.generic-request-failed'),
									);
								},
								'POST',
							);
						} else {
							t.removeClass('d-none');
							spinner.addClass('d-none');

							showCallbackError(
								_t(
									'seller_settings_credits:large-pack-purchase.request-callback.form.phone-number-error',
								),
							);
						}
					},
					false,
					'seller',
				);
			});

		$('.js-close-large-pack-modal')
			.off('click.closeCallout')
			.on('click.closeCallout', closeCallout);

		$('#large-pack-callback-tel')
			.off('keyup.format')
			.on('keyup.format', function (e) {
				if (Bark.in_array(e.keyCode, [8, 37, 39])) {
					return false;
				}

				this.value = new AsYouType((Bark.ENV.locale || 'GB').toUpperCase()).input(
					this.value,
				);
			})
			.trigger('keyup.format');

		$('.js-close-largepack-callback-modal')
			.off('click.closeModal')
			.on('click.closeModal', () => {
				$('.modal').modal('hide');
				$('#large-pack-modal').modal('show');
			});

		onPaymentIntentSuccessRedirect();
	});

	function showCallbackError(msg) {
		var container = $('.js-callback-error-container');

		container.removeClass('d-none');
		$('.js-msg', container).text(msg);
	}

	/**
	 * Show the error modal
	 * @param {errorObject} errObject The response obj from the API which caused the error. Malformed objects will default to message
	 * @param {boolean} keepModalsOpen [optional] True to keep the current modal open
	 * @param {string} msg [optional] The error message to show
	 */
	function showErrors(errObject, keepModalsOpen, msg) {
		if (typeof msg === 'undefined') {
			msg = _t('seller_settings_credits:errors.generic-request-failed');
		}
		if (!keepModalsOpen) {
			$('.modal').modal('hide');
		}
		var newObj = handleErrors(errObject, msg);
		modalManager.set(
			'',
			'',
			'<div class="d-flex justify-content-center align-items-center text-center"><h4 class="js-error">' +
				newObj.message +
				'</h4></div>',
			[
				`<span class="btn btn-primary mx-auto" data-dismiss="modal">${_t(
					'common:alert-confirm-modals.close-button',
				)}</span>`,
			],
			'modal-sm',
		);
		Bark.hideLoading();
	}

	function handleErrors(errorResponse, defaultMessage) {
		var message = _t('seller_settings_credits:errors.error-occurred');
		if (typeof defaultMessage !== 'undefined') {
			message = defaultMessage;
		}
		var fallbackError = true;
		var validationObj = {};
		if (typeof errorResponse.status !== 'undefined') {
			if (
				typeof errorResponse.responseJSON !== 'undefined' &&
				typeof errorResponse.responseJSON.error !== 'undefined'
			) {
				var errorObj = errorResponse.responseJSON.error;
				if (errorObj.status_code < 500 && typeof errorObj.message !== 'undefined') {
					message = errorObj.message;
				}
				if (errorObj.status_code === 422 && typeof errorObj.errors !== 'undefined') {
					validationObj = errorObj.errors;
					fallbackError = false;
				}
				if (errorObj.status_code === 402 && isMultiPaymentModalAvailable()) {
					creditCardTracking.logAction('payment failure', {
						payment_method: $('#payment-accordion .collapse.open').data('payment-method'),
					});
				}
			}
		}
		if (fallbackError) {
			// for now just through alert
			return {
				message: message,
			};
		} else {
			return {
				message: message,
				validation: validationObj,
			};
		}
	}
}
